export const isIOSDevice = (/iPad|iPhone|iPod/i.test(navigator.platform) ||
(navigator?.platform === 'MacIntel' && navigator?.maxTouchPoints > 1)) &&
!window?.MSStream;
